<template>
    <div class="form c-form c-form-after-list">
        <div style="cursor: pointer" @click="showHideForm">
            <h4 class="c-question c-question-first">
                La que Babyplant me recomiende
            </h4>
            <i class="fas" :class="'fa-chevron-'+(showForm ? 'up' : 'down')"></i>
        </div>
        <div v-show="showForm">
            <p>
                Rellena el siguiente formulario y en breve te daremos una respuesta
            </p>
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Nombre" aria-label="Nombre"
                       v-model="form.nombre" :class="((errors['nombre']) ? 'is-invalid' : '')">
            </div>
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Móvil" aria-label="Movil" v-model="form.movil"
                       :class="((errors['movil']) ? 'is-invalid' : '')">
            </div>
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Correo electrónico" v-model="form.email"
                       :class="((errors['email']) ? 'is-invalid' : '')" aria-label="Correo electrónico">
            </div>
            <div class="form-group">
                <textarea type="text" class="form-control" placeholder="¿Qué necesitas?" v-model="form.mensaje"
                          :class="((errors['mensaje']) ? 'is-invalid' : '')" aria-label="¿Qué necesitas?"></textarea>
            </div>
            <p>Al envíar el formulario, aceptas los <a href="/terminos-condiciones">términos y
                condiciones</a> y la <a href="/politica-privacidad">política de privacidad</a>.</p>
            <b-button class="send-btn" variant="outline-light" @click="submit" :disabled="loading">
                Enviar
            </b-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InjertoSelectForm",
        data() {
            return {
                showForm: false,
                loading: false,
                form: {
                    nombre: "",
                    movil: "",
                    semana: "",
                    producto: "",
                    type: "bp_recomendacion_injerto",
                    email: "",
                    mensaje: ""
                },
                formSent: false,
                errors: []
            }
        },
        computed: {
            producto() {
                let producto = "";
                let variety = this.$store.state.custom.varietySelected;
                if (variety) {
                    producto = variety.mote.especie.nombre + ' ' + variety.mote.nombre + ' ' + variety.nombre;
                }
                return producto;
            }
        },
        watch: {
            producto(newVal) {
                this.form.producto = newVal;
            }
        },
        methods: {
            showHideForm() {
                this.showForm = !this.showForm;
            },
            submit() {
                this.loading = true;

                axios.post(this.route('send.contact'), this.form).then(response => {
                    this.errors = [];
                    this.formSent = true;
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });

                    this.form = {nombre: "", movil: "", email: "", mensaje: ""};
                }).catch(e => {
                    this.errors = e.response.data.errors;

                    Vue.toasted.show(e.response.data.info ? e.response.data.info : 'Ha habido un error', {
                        type: "error",
                        duration: 3000
                    });

                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        created() {
            this.form.producto = this.producto;
        }
    }
</script>

<style scoped>
    .c-form {
        padding: 1.5em;
        background-color: #d7db2d;
        margin-top: -5px;
        position: relative;
    }

    .send-btn {
        display: block;
        border-color: #0871b8;
        text-align: center;
        text-decoration: none;
        font-weight: bold;
        color: #0871b8;
        width: 100%;
        cursor: pointer;
        border-radius: 4px;
        border: 2px solid;
        transition: all 0.15s ease;
        padding: 5px;
        max-width: 250px;
        margin: auto;
    }

    .c-form-after-list {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .c-question.c-question-first, .c-question.c-question-second, .fa-chevron-up, .fa-chevron-down {
        color: #0871b8;
    }

    .c-question.c-question-first {
        font-weight: bold;
    }

    .c-question.c-question-first, .c-question.c-question-second {
        margin-bottom: 0.2em;
    }

    input, textarea {
        border-radius: 0;
        font-weight: bold;
    }

</style>
